import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import './EventCard.css';

const EventCard = ({ event }) => {
  const { image, date, title, description, venue, slug } = event;

  return (
    <div className="event-card">
      <div className="event-card-image-wrapper">
        <img src={image} alt={title} className="event-card-image" />
        <div className="event-date-badge">
          <span className="event-date-day">{date.day}</span>
          <span className="event-date-month">{date.month}</span>
        </div>
      </div>
      <div className="event-card-content">
        <h3 className="event-title">
          <Link to={`/events/${slug}`}>{title}</Link>
        </h3>
        <p className="event-description">{description}</p>
        <div className="event-venue">
          <MapPin size={16} />
          <span><strong>Venue:</strong> {venue}</span>
        </div>
        <Link to={`/events/${slug}`} className="event-details-link">
          Event Details <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
};

export default EventCard;
